enum AlertsType {
  ERROR = 'error',
  WARNING = 'warning',
  ACTION = 'action',
  INFO = 'info',
}

enum TextLinkStyle {
  UNDERLINE = 'underline',
  NO_DECORATION = 'no_decoration',
}

export { AlertsType, TextLinkStyle };
